import { styled, Grid } from "@mui/material";
import Rectangle from "../../../../assets/images/rectangle.svg";
import RectangleDown from "../../../../assets/images/rectangle-down.svg";

export const Wrapper = styled(Grid)({
  display: "flex",
  gap: "20px" /* Space between elements */,
  justifyContent: "center" /* Center grid items */,
  alignItems: "end" /* Align them at the bottom */,
});

export const Container = styled(Grid)(({ theme }) => ({
  backgroundImage: `url(${Rectangle})`,
  height: "150px",
  width: "165px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "end",
  alignItems: "center",
  textAlign: "center",
  paddingBottom: "21px",
  color: theme.palette.primary.main,
  backgroundRepeat: "no-repeat",
  backgroundSize: "contain",
  "& p": {
    width: "80%",
  },
}));

export const SecondContainer = styled(Grid)(({ theme }) => ({
  backgroundImage: `url(${RectangleDown})`,
  height: "150px",
  width: "165px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "start",
  alignItems: "center",
  textAlign: "center",
  paddingTop: "21px",
  color: theme.palette.error.main,
  backgroundRepeat: "no-repeat",
  marginLeft: "-75px",
  marginTop: "56px",
  backgroundSize: "contain",
  "& p": {
    width: "80%",
  },
}));
